<template>
  <div @click="medicineChestOpen = false">
    <div class="personal-header">
      <HeaderBlock :isHideSearch="false" />
    </div>
    <section class="personal-section">
      <PersonalLeftBlock :hrefTo="'medicine_chest'" />
      <div class="block-right block-medicine-chest">
        <a @click="$router.push({ name: 'personal' })" class="back">
          В профиль
        </a>
        <div class="div-headline-1" v-if="medicineChest">
          Аптечка -
          <span
            @click.stop="
              medicineChestOpen === true
                ? (medicineChestOpen = false)
                : (medicineChestOpen = true)
            "
          >
            {{ medicineChest.name }}
          </span>
          <div v-if="medicineChestOpen" class="block">
            <span
              v-for="item in medicineChestList"
              :key="item"
              :class="{ active: item.id === medicineChest.id }"
              @click.stop="(medicineChest = item), (medicineChestOpen = false)"
            >
              {{ item.name }}
            </span>
            <span
              @click.stop="
                (isOpenMedicineChest = true), (openMedicineChest = 'new')
              "
            >
              Создать аптечку
            </span>
          </div>
        </div>
        <h1 v-else>Аптечка</h1>
        <div class="medicine-chest-add" v-if="medicineChest">
          <p>
            Добавляйте прием препаратов и получайте уведомления.
            <br />
            Это позволит вам соблюдать курс приема.
          </p>
          <button
            @click.stop="
              (isOpenReceptionProduct = true),
                (receptionProduct = null),
                (openMedicineChestReception = 'new')
            "
          >
            Добавить прием
          </button>
          <span @click.stop="medicineChestSettings()">Настройки</span>
        </div>
        <div class="medicine-chest-add" v-else>
          <p>
            Создайте аптечку и это позволит вам контролировать прием <br />
            препаратов и получайте уведомления для соблюдения курса приема.
          </p>
          <button
            @click.stop="
              (isOpenMedicineChest = true), (openMedicineChest = 'new')
            "
          >
            Создать аптечку
          </button>
          <a href="/" target="_blank">Подробнее</a>
        </div>
        <img
          v-if="isLoading"
          src="@/assets/images/shop-loading.svg"
          class="loading"
        />
        <div class="calendar-date" v-if="this.calendarDays.length > 0">
          <swiper
            class="swiper"
            :modules="modules"
            :slides-per-view="slidesPerView"
            :initialSlide="initialSlide"
            :space-between="10"
            :loop="false"
            :navigation="true"
            :allow-touch-move="valueAllowTouchMove"
            :style="{
              '--swiper-navigation-color': '#000000',
              '--swiper-navigation-size': '22px',
            }"
          >
            <swiper-slide
              v-for="item in calendarDays"
              :key="item"
              @click="selectedCalendarDate = String(item)"
              :class="{ active: String(item) === selectedCalendarDate }"
            >
              <div>
                <span>{{ getWeekName(item) }}</span>
                <span>{{ getDayMonthName(item) }}</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="medicineChest">
          <div
            v-for="item in receptionsDisplay"
            :key="item"
            class="receptions-items"
          >
            <span v-if="item.type === 1">
              Утром до еды
              <span>в {{ getMinMinute(medicineChest.morning_hours) }}</span>
            </span>
            <span v-if="item.type === 2">
              Утром во время еды
              <span>в {{ medicineChest.morning_hours }}</span>
            </span>
            <span v-if="item.type === 3">
              Утром после еды
              <span>в {{ getPlusHours(medicineChest.morning_hours) }}</span>
            </span>
            <span v-if="item.type === 4">
              Днем во время еды <span>в {{ medicineChest.lunch_hours }}</span>
            </span>
            <span v-if="item.type === 5">
              Днем, через 1 час после еды
              <span>в {{ getPlusHours(medicineChest.lunch_hours) }}</span>
            </span>
            <span v-if="item.type === 6">
              Вечером, во время еды
              <span> в {{ medicineChest.supper_hours }}</span>
            </span>
            <span v-if="item.type === 7">
              Вечером, перед сном
              <span>в {{ getMinMinute(medicineChest.night_hours) }}</span>
            </span>
            <div
              class="reception-item"
              v-for="product in item.products"
              :key="product"
              @click.stop="medicineChestReceptionSettings(product)"
              :class="{ acceptance: product.status === 2 }"
            >
              <img
                v-if="product.product"
                :src="product.product.images[0].image.image_object_small"
              />
              <img v-else :src="apiUrl + 'static/images/none-product.png'" />
              <span v-if="product.status === 2" class="success"></span>
              <div class="info">
                <span class="name" v-if="product.product">
                  {{ product.product.headline_preview }}
                </span>
                <span class="name" v-else>{{ product.product_name }}</span>
                <span class="number" v-if="product.status === 1">
                  Прием: {{ product.number_of_capsules }}
                  {{ getReceptionDeclination(product) }}
                </span>
                <span class="number" v-else>Прием выполнен</span>
              </div>
              <button
                @click.stop="confirmAcceptance(product)"
                v-if="product.status === 1"
              >
                Подтвердить прием
              </button>
              <div class="delay" v-if="product.delayMobile">
                <a
                  @click.stop="
                    (product.delayMobile = false), (delayMobile = false)
                  "
                >
                  Назад
                </a>
                <span
                  v-if="product.status === 1"
                  @click.stop="
                    confirmAcceptance(product),
                      (product.delayMobile = false),
                      (delayMobile = false)
                  "
                >
                  Подтвердить прием
                </span>
                <button
                  @click.stop="medicineChestReceptionSettings(product, true)"
                >
                  Настроить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="medicine-chest-mobile" v-if="medicineChest">
        <span @click.stop="medicineChestSettings()">Настройки</span>
        <button
          @click.stop="
            (isOpenReceptionProduct = true),
              (receptionProduct = null),
              (openMedicineChestReception = 'new')
          "
        >
          Добавить препарат
        </button>
      </div>
    </section>
    <div class="personal-footer">
      <FooterBlock />
    </div>
  </div>

  <div
    v-if="isOpenMedicineChestReception"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="isOpenMedicineChestReception = null"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5 v-if="openMedicineChestReception === 'new'">
          Добавить прием препарата
        </h5>
        <h5 v-else>Редактировать прием</h5>
        <div class="select-group-product" @click="clickOpenReceptionProduct()">
          <img
            v-if="receptionProduct === 'other'"
            :src="apiUrl + 'static/images/none-product.png'"
          />
          <img
            v-else-if="receptionProduct"
            :src="receptionProduct.images[0].image.image_object_small"
          />
          <span v-if="receptionProduct === 'other'">
            <span>{{ receptionProductOther }}</span>
            <span></span>
          </span>
          <span v-else-if="receptionProduct">
            <span>{{ receptionProduct.headline_preview }}</span>
            <span>
              {{ receptionProduct.feature_product_quantity }}
              <span v-if="receptionProduct.release_form">
                {{
                  getDeclination(
                    receptionProduct.feature_product_quantity,
                    receptionProduct.release_form
                  )
                }}
              </span>
            </span>
          </span>
          <button>Изменить</button>
        </div>
        <div class="number-of-capsules">
          <small v-if="receptionProduct === 'other'">Прием, шт.</small>
          <small v-else-if="receptionProduct">
            Прием, {{ receptionProduct.release_form.name }}
          </small>
          <small v-else>Прием</small>
          <div>
            <span
              :class="{ active: receptionNumber === item }"
              @click="receptionNumber = item"
              v-for="item in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
              :key="item"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div class="edit-group" @click="clickOpenReceptionType">
          <small>Время приема</small>
          <span>{{ receptionType }}</span>
          <a>Изменить</a>
        </div>
        <div class="edit-group" @click="clickOpenReceptionFrequency">
          <small>Частота приема</small>
          <span>{{ receptionFrequency }}</span>
          <a>Изменить</a>
        </div>
        <div class="time-group">
          <small>Начало приема</small>
          <div class="items">
            <span
              :class="{ active: receptionStart === 'today' }"
              @click="
                (receptionStart = 'today'),
                  (receptionStartDate = null),
                  updateReceptionStopDays()
              "
            >
              Сегодня
            </span>
            <span
              :class="{ active: receptionStart === 'tomorrow' }"
              @click="
                (receptionStart = 'tomorrow'),
                  (receptionStartDate = null),
                  updateReceptionStopDays()
              "
            >
              Завтра
            </span>
            <Datepicker
              v-model="receptionStartDate"
              :locale="ru"
              placeholder="Указать"
              :class="{ active: receptionStart === 'other' }"
              :inputFormat="'dd.MM.yyyy'"
            />
          </div>
        </div>
        <div class="time-group">
          <small>Курс приема</small>
          <div class="items">
            <span
              :class="{ active: receptionStopDays === '30' }"
              @click="receptionStopDays = '30'"
            >
              1 мес.
            </span>
            <span
              :class="{ active: receptionStopDays === '60' }"
              @click="receptionStopDays = '60'"
            >
              2 мес.
            </span>
            <span
              :class="{ active: receptionStopDays === '90' }"
              @click="receptionStopDays = '90'"
            >
              3 мес.
            </span>
            <span
              v-if="
                receptionStopDays !== '30' &&
                receptionStopDays !== '60' &&
                receptionStopDays !== '90'
              "
              class="active"
              @click="clickOpenReceptionDate"
            >
              {{ dateFormatString(receptionStopDate) }}
            </span>
            <span v-else @click="clickOpenReceptionDate">Указать</span>
          </div>
        </div>
        <button class="button-save" @click="saveMedicineChestReception()">
          Сохранить
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="openMedicineChestSettings"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="openMedicineChestSettings = null"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Настройки</h5>
        <div class="setting-block">
          <div>
            <span>
              <span>Название</span>
              <span>{{ medicineChestName }}</span>
            </span>
            <span>
              <span>Часовой пояс</span>
              <span>{{ mcTimezone }}</span>
            </span>
            <span>
              <span>Завтрак</span>
              <span>{{ medicineChestMorning }}</span>
            </span>
            <span>
              <span>Обед</span>
              <span>{{ medicineChestLunch }}</span>
            </span>
            <span>
              <span>Ужин</span>
              <span>{{ medicineChestSupper }}</span>
            </span>
            <span>
              <span>Сон</span>
              <span>{{ medicineChestNight }}</span>
            </span>
          </div>
          <span
            @click="
              (openMedicineChestSettings = false),
                (openMedicineChest = medicineChest.id),
                (isOpenMedicineChest = true)
            "
          >
            Настроить
          </span>
        </div>
        <p>
          <span v-if="isNotificationTg">Оповещение в телеграмм подключено</span>
          <span v-else>Оповещение в телеграмм</span>
          <button
            class="active"
            v-if="isNotificationTg"
            @click.stop="clickNotificationTg(false)"
          >
            Отключить
          </button>
          <button v-else @click.stop="clickNotificationTg(true)">
            Подключить
          </button>
        </p>
        <p>
          <span v-if="isNotificationEmail">
            Оповещение по e-mail подключено
          </span>
          <span v-else>Оповещение по e-mail</span>
          <button
            class="active"
            v-if="isNotificationEmail"
            @click.stop="clickNotificationEmail(false)"
          >
            Отключить
          </button>
          <button v-else @click.stop="clickNotificationEmail(true)">
            Подключить
          </button>
        </p>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenMedicineChest"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="isOpenMedicineChest = null"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5 v-if="openMedicineChest === 'new'">Создание аптечки</h5>
        <h5 v-else>Настройки</h5>
        <div class="group-input" :class="{ error: isMedicineChestName }">
          <small>Название</small>
          <input
            type="text"
            placeholder="Название"
            v-model="medicineChestName"
          />
        </div>
        <div class="edit-group">
          <small>Часовой пояс</small>
          <span>{{ mcTimezone }}</span>
          <a @click="clickOpenMedicineChestTimezone">Изменить</a>
        </div>
        <div class="time-group">
          <small>Время завтрака</small>
          <swiper
            class="swiper"
            :modules="modules"
            :slides-per-view="5"
            :initialSlide="4"
            :space-between="0"
            :loop="false"
            :navigation="false"
            :allow-touch-move="true"
          >
            <swiper-slide
              v-for="item in [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23, 0,
              ]"
              :key="item"
            >
              <span
                @click="medicineChestMorning = item + ':00'"
                :class="{ active: medicineChestMorning === item + ':00' }"
              >
                {{ item }}:00
              </span>
            </swiper-slide>
          </swiper>
        </div>
        <div class="time-group">
          <small>Время обеда</small>
          <swiper
            class="swiper"
            :modules="modules"
            :slides-per-view="5"
            :initialSlide="12"
            :space-between="0"
            :loop="false"
            :navigation="false"
            :allow-touch-move="true"
          >
            <swiper-slide
              v-for="item in [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23, 0,
              ]"
              :key="item"
            >
              <span
                @click="medicineChestLunch = item + ':00'"
                :class="{ active: medicineChestLunch === item + ':00' }"
              >
                {{ item }}:00
              </span>
            </swiper-slide>
          </swiper>
        </div>
        <div class="time-group">
          <small>Время ужина</small>
          <swiper
            class="swiper"
            :modules="modules"
            :slides-per-view="5"
            :initialSlide="17"
            :space-between="0"
            :loop="false"
            :navigation="false"
            :allow-touch-move="true"
          >
            <swiper-slide
              v-for="item in [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23, 0,
              ]"
              :key="item"
            >
              <span
                @click="medicineChestSupper = item + ':00'"
                :class="{ active: medicineChestSupper === item + ':00' }"
              >
                {{ item }}:00
              </span>
            </swiper-slide>
          </swiper>
        </div>
        <div class="time-group">
          <small>Время отхода ко сну</small>
          <swiper
            class="swiper"
            :modules="modules"
            :slides-per-view="5"
            :initialSlide="23"
            :space-between="0"
            :loop="false"
            :navigation="false"
            :allow-touch-move="true"
          >
            <swiper-slide
              v-for="item in [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23, 0,
              ]"
              :key="item"
            >
              <span
                @click="medicineChestNight = item + ':00'"
                :class="{ active: medicineChestNight === item + ':00' }"
              >
                {{ item }}:00
              </span>
            </swiper-slide>
          </swiper>
        </div>
        <button class="button-save" @click="saveMedicineChest(true)">
          Сохранить
        </button>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenMedicineChestTimezone"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenMedicineChestTimezone"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Часовой пояс</h5>
        <div class="timezone-block">
          <span
            @click="
              (mcTimezone = 'Europe/Kaliningrad (+02:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Kaliningrad (+02:00)' }"
          >
            <span>+02:00</span>
            Europe/Kaliningrad
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Moscow (+03:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Moscow (+03:00)' }"
          >
            <span>+03:00</span>
            Europe/Moscow
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Kirov (+03:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Kirov (+03:00)' }"
          >
            <span>+03:00</span>
            Europe/Kirov
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Astrakhan (+04:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Astrakhan (+04:00)' }"
          >
            <span>+04:00</span>
            Europe/Astrakhan
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Volgograd (+04:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Volgograd (+04:00)' }"
          >
            <span>+04:00</span>
            Europe/Volgograd
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Saratov (+04:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Saratov (+04:00)' }"
          >
            <span>+04:00</span>
            Europe/Saratov
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Ulyanovsk (+04:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Ulyanovsk (+04:00)' }"
          >
            <span>+04:00</span>
            Europe/Ulyanovsk
          </span>
          <span
            @click="
              (mcTimezone = 'Europe/Samara (+04:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Europe/Samara (+04:00)' }"
          >
            <span>+04:00</span>
            Europe/Samara
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Yekaterinburg (+05:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Yekaterinburg (+05:00)' }"
          >
            <span>+05:00</span>
            Asia/Yekaterinburg
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Omsk (+06:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Omsk (+06:00)' }"
          >
            <span>+06:00</span>
            Asia/Omsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Novosibirsk (+07:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Novosibirsk (+07:00)' }"
          >
            <span>+07:00</span>
            Asia/Novosibirsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Barnaul (+07:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Barnaul (+07:00)' }"
          >
            <span>+07:00</span>
            Asia/Barnaul
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Tomsk (+07:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Tomsk (+07:00)' }"
          >
            <span>+07:00</span>
            Asia/Tomsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Novokuznetsk (+07:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Novokuznetsk (+07:00)' }"
          >
            <span>+07:00</span>
            Asia/Novokuznetsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Krasnoyarsk (+07:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Krasnoyarsk (+07:00)' }"
          >
            <span>+07:00</span>
            Asia/Krasnoyarsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Irkutsk (+08:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Irkutsk (+08:00)' }"
          >
            <span>+08:00</span>
            Asia/Irkutsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Chita (+09:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Chita (+09:00)' }"
          >
            <span>+09:00</span>
            Asia/Chita
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Yakutsk (+09:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Yakutsk (+09:00)' }"
          >
            <span>+09:00</span>
            Asia/Yakutsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Khandyga (+09:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Khandyga (+09:00)' }"
          >
            <span>+09:00</span>
            Asia/Khandyga
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Vladivostok (+10:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Vladivostok (+10:00)' }"
          >
            <span>+10:00</span>
            Asia/Vladivostok
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Ust-Nera (+10:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Ust-Nera (+10:00)' }"
          >
            <span>+10:00</span>
            Asia/Ust-Nera
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Magadan (+11:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Magadan (+11:00)' }"
          >
            <span>+11:00</span>
            Asia/Magadan
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Sakhalin (+11:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Sakhalin (+11:00)' }"
          >
            <span>+11:00</span>
            Asia/Sakhalin
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Srednekolymsk (+11:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Srednekolymsk (+11:00)' }"
          >
            <span>+11:00</span>
            Asia/Srednekolymsk
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Kamchatka (+12:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Kamchatka (+12:00)' }"
          >
            <span>+12:00</span>
            Asia/Kamchatka
          </span>
          <span
            @click="
              (mcTimezone = 'Asia/Anadyr (+12:00)'),
                clickOpenMedicineChestTimezone()
            "
            :class="{ active: mcTimezone === 'Asia/Anadyr (+12:00)' }"
          >
            <span>+12:00</span>
            Asia/Anadyr
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenReceptionType"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenReceptionType"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Время приема</h5>
        <div class="timezone-block">
          <span
            @click="(receptionType = 'Утром до еды'), clickOpenReceptionType()"
            :class="{ active: receptionType === 'Утром до еды' }"
          >
            <span>Утром до еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Утром во время еды'), clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Утром во время еды' }"
          >
            <span>Утром во время еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Утром после еды'), clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Утром после еды' }"
          >
            <span>Утром после еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Днем во время еды'), clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Днем во время еды' }"
          >
            <span>Днем во время еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Днем, через 1 час после еды'),
                clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Днем, через 1 час после еды' }"
          >
            <span>Днем, через 1 час после еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Вечером, во время еды'),
                clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Вечером, во время еды' }"
          >
            <span>Вечером, во время еды</span>
          </span>
          <span
            @click="
              (receptionType = 'Вечером, перед сном'), clickOpenReceptionType()
            "
            :class="{ active: receptionType === 'Вечером, перед сном' }"
          >
            <span>Вечером, перед сном</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenReceptionFrequency"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenReceptionFrequency"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Частота приема</h5>
        <div class="timezone-block">
          <span
            @click="
              (receptionFrequency = 'Ежедневно'), clickOpenReceptionFrequency()
            "
            :class="{ active: receptionFrequency === 'Ежедневно' }"
          >
            <span>Ежедневно</span>
          </span>
          <span
            @click="
              (receptionFrequency = '1 день прием и 1 день перерыв'),
                clickOpenReceptionFrequency()
            "
            :class="{
              active: receptionFrequency === '1 день прием и 1 день перерыв',
            }"
          >
            <span>1 день прием и 1 день перерыв</span>
          </span>
          <span
            @click="
              (receptionFrequency = '2 дня прием и 2 дня перерыв'),
                clickOpenReceptionFrequency()
            "
            :class="{
              active: receptionFrequency === '2 дня прием и 2 дня перерыв',
            }"
          >
            <span>2 дня прием и 2 дня перерыв</span>
          </span>
          <span
            @click="
              (receptionFrequency = '5 дней прием и 2 дня перерыв'),
                clickOpenReceptionFrequency()
            "
            :class="{
              active: receptionFrequency === '5 дней прием и 2 дня перерыв',
            }"
          >
            <span>5 дней прием и 2 дня перерыв</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenReceptionProduct"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenReceptionProduct"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Продукт</h5>
        <div class="group-input">
          <input
            placeholder="Введите название для поиска"
            class="full"
            v-model="searchValue"
          />
        </div>
        <div class="products-items-block">
          <div
            :class="{ active: receptionProduct === 'other' }"
            @click="clickOpenReceptionProductOther()"
          >
            <img :src="apiUrl + 'static/images/none-product.png'" />
            <span v-if="receptionProductOther">
              <span class="name">{{ receptionProductOther }}</span>
              <span class="description"></span>
            </span>
            <span v-else>
              <span class="name">Продукт другого бренда</span>
              <span class="description">не из линейки UltraBalance</span>
            </span>
            <button v-if="receptionProduct === 'other'" class="important">
              Изменить
            </button>
            <button v-else>Выбрать</button>
          </div>
          <div
            v-for="item in productsDisplay"
            :key="item"
            :class="{ active: receptionProduct === item }"
            @click="clickOpenReceptionProduct(item)"
          >
            <img :src="item.images[0].image.image_object_small" />
            <span>
              <span class="name">{{ item.headline_preview }}</span>
              <span class="description">
                {{ item.feature_product_quantity }}
                <span v-if="item.release_form">
                  {{
                    getDeclination(
                      item.feature_product_quantity,
                      item.release_form
                    )
                  }}
                </span>
              </span>
            </span>
            <button>Выбрать</button>
          </div>
        </div>
        <span
          v-if="receptionProduct"
          class="button-close"
          @click="clickOpenReceptionProduct(false)"
        >
          Отменить
        </span>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenReceptionProductOther"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenReceptionProductOther(false)"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Продукт</h5>
        <div class="group-input">
          <small>Укажите название</small>
          <input v-model="receptionProductOther" />
        </div>
        <button
          class="button-save"
          @click="clickOpenReceptionProductOther(true)"
        >
          Сохранить
        </button>
        <span
          class="button-close"
          @click="clickOpenReceptionProductOther(false)"
        >
          Отменить
        </span>
      </div>
    </div>
  </div>
  <div
    v-if="isOpenReceptionDate"
    class="profile-popup reception-popup shop-popup"
  >
    <div class="content">
      <img
        @click="clickOpenReceptionDate"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <div>
        <h5>Курс приема</h5>
        <div class="group-input">
          <small>Срок в днях</small>
          <input
            v-model="receptionStopDays"
            @keyup.stop="updateReceptionStopDays()"
          />
        </div>
        <div class="group-input reception-date">
          <small>Дата окончания</small>
          <Datepicker
            v-model="receptionStopDate"
            :locale="ru"
            placeholder="Указать"
            @update:model-value="updateReceptionStopDate()"
            :inputFormat="'dd.MM.yyyy'"
          />
        </div>
        <button class="button-save" @click="clickOpenReceptionDate()">
          Сохранить
        </button>
      </div>
    </div>
  </div>
  <div v-if="delayMobile" class="delay-mobile" @click="closeDelayMobile"></div>
</template>
<script>
import jsMixin from "@/mixins/jsMixin";
import mainMixin from "@/mixins/mainMixin";
import pageMixin from "@/mixins/pageMixin";
import productMixin from "@/mixins/productMixin";
import profileMixin from "@/mixins/profileMixin";
import HeaderBlock from "@/components/HeaderBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";
import PersonalLeftBlock from "@/components/PersonalLeftBlock.vue";
import Datepicker from "vue3-datepicker";
import "@/assets/css/personal.css";
import { ru } from "date-fns/locale";
import api from "@/api";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Navigation } from "swiper";
import Const from "@/api/const";

export default {
  mixins: [jsMixin, mainMixin, pageMixin, productMixin, profileMixin],
  components: {
    HeaderBlock,
    FooterBlock,
    PersonalLeftBlock,
    Datepicker,
    SwiperSlide,
    Swiper,
  },
  setup() {
    return {
      modules: [Navigation],
    };
  },
  data() {
    return {
      ru: ru,
      searchValue: "",
      products: {},
      productsDisplay: {},
      medicineChestOpen: false,
      receptionType: "Утром до еды",
      isOpenReceptionType: false,
      receptionFrequency: "Ежедневно",
      isOpenReceptionFrequency: false,
      isOpenReceptionDate: false,
      receptionStart: "other",
      receptionStartDate: null,
      receptionStopDate: null,
      receptionStopDays: "1",
      receptionNumber: 1,
      isReceptionProduct: false,
      receptionProduct: null,
      isOpenReceptionProduct: null,
      isOpenReceptionProductOther: null,
      isReceptionProductOther: false,
      receptionProductOther: "",
      medicineChest: null,
      medicineChestList: [],
      isOpenMedicineChest: false,
      openMedicineChest: null,
      openMedicineChestSettings: null,
      medicineChestName: "",
      mcTimezone: "Europe/Moscow (+03:00)",
      isOpenMedicineChestTimezone: false,
      medicineChestMorning: "8:00",
      medicineChestLunch: "14:00",
      medicineChestSupper: "19:00",
      medicineChestNight: "23:00",
      isMedicineChestName: false,
      isOpenMedicineChestReception: false,
      openMedicineChestReception: null,
      initialSlide: 0,
      calendarDays: [],
      selectedCalendarDate: null,
      receptions: [],
      receptionsDisplay: {},
      isNotificationTg: false,
      isNotificationEmail: false,
      apiUrl: Const.API_URL,
      isLoading: false,
      slidesPerView: 8,
      valueAllowTouchMove: true,
      delayMobile: false,
    };
  },
  watch: {
    receptionStart() {
      this.updateReceptionStopDays();
    },
    receptionStopDate(value) {
      console.log(value);
    },
    receptionStartDate(value) {
      if (!value) return false;
      let date = new Date(value);
      let tomorrow = new Date();
      let now = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (this.checkDates(date, now)) {
        this.receptionStart = "today";
      } else if (this.checkDates(date, tomorrow)) {
        this.receptionStart = "tomorrow";
      } else {
        this.receptionStart = "other";
      }
    },
    searchValue(value) {
      value = value.toLowerCase();
      this.productsDisplay = {};
      for (let item in this.products) {
        item = this.products[item];
        let name = item["headline_preview"].toLowerCase();
        if (name.indexOf(value) !== -1) {
          this.productsDisplay[item["id"]] = item;
        }
      }
    },
    isOpenMedicineChest(value) {
      if (value) this.isOpenPopup(true);
      else this.isOpenPopup(false);
    },
    openMedicineChestSettings(value) {
      if (value) this.isOpenPopup(true);
      else this.isOpenPopup(false);
    },
    isOpenMedicineChestReception(value) {
      if (value) this.isOpenPopup(true);
      else this.isOpenPopup(false);
    },
    openMedicineChestReception(value) {
      if (value === "new") {
        this.receptionType = "Утром до еды";
        this.receptionProduct = false;
        this.receptionProductOther = "";
        this.receptionNumber = 1;
        this.receptionStart = "today";
        this.updateReceptionStopDays();
        this.receptionStartDate = null;
        this.receptionStopDays = "30";
        this.receptionFrequency = "Ежедневно";
        this.updateReceptionStopDays();
      }
    },
    medicineChest(value) {
      this.isLoading = true;
      this.getMedicineChestReceptions(value.id);
      localStorage.setItem("medicineChestId", value.id);
    },
    selectedCalendarDate(value) {
      this.getReceptionsDisplay(value);
    },
  },
  mounted() {
    let that = this;
    document.addEventListener("keydown", function (evt) {
      if (evt.which === 27) {
        that.isOpenMedicineChestReception = null;
        that.isOpenMedicineChest = null;
        that.openMedicineChestSettings = null;
        that.isOpenPopup(false);
      }
    });
  },
  async created() {
    document.title = "Моя аптечка";
    let medicineChestId = localStorage.getItem("medicineChestId");
    try {
      const result = await api.shop.getShopAllProducts();
      for (let item in result["data"]["results"]) {
        item = result["data"]["results"][item];
        this.products[item["id"]] = item;
      }
      this.productsDisplay = this.products;
    } catch (error) {
      console.log(error);
    }
    try {
      const result = await api.shop.getMedicineChests();
      this.medicineChestList = result["data"]["results"];
      if (this.medicineChestList.length > 0) {
        if (medicineChestId) {
          for (let item in this.medicineChestList) {
            item = this.medicineChestList[item];
            if (item["id"] === Number(medicineChestId)) {
              this.medicineChest = item;
            }
          }
        }
        if (!this.medicineChest) this.medicineChest = this.medicineChestList[0];
      }
    } catch (error) {
      console.log(error);
    }

    if (window.innerWidth < 900) {
      this.slidesPerView = 5;
    } else this.valueAllowTouchMove = false;
    await api.shop.postViewStatistics({ type: 11 });
  },
  methods: {
    updateReceptionProduct() {
      let value = this.receptionProduct;
      if (value !== "other") {
        if (value["reception_time"] === 1) this.receptionType = "Утром до еды";
        if (value["reception_time"] === 2) {
          this.receptionType = "Утром во время еды";
        }
        if (value["reception_time"] === 3) {
          this.receptionType = "Утром после еды";
        }
        if (value["reception_time"] === 4) {
          this.receptionType = "Днем во время еды";
        }
        if (value["reception_time"] === 5) {
          this.receptionType = "Днем, через 1 час после еды";
        }
        if (value["reception_time"] === 6) {
          this.receptionType = "Вечером, во время еды";
        }
        if (value["reception_time"] === 7) {
          this.receptionType = "Вечером, перед сном";
        }
        if (value["course_of_admission"]) {
          this.receptionStopDays = String(value["course_of_admission"]);
        } else this.receptionStopDays = "30";
        this.updateReceptionStopDays();
        if (value["dosage"]) this.receptionNumber = Number(value["dosage"]);
      } else {
        this.receptionStopDays = "30";
        this.updateReceptionStopDays();
      }
    },
    updateReceptionStopDays() {
      if (this.receptionStopDays) {
        let date = new Date();
        if (this.receptionStart === "tomorrow") {
          date.setDate(date.getDate() + 1);
        }
        if (this.receptionStart === "other") {
          date = new Date(this.receptionStartDate);
        }
        if (!this.receptionStopDays) this.receptionStopDays = "30";
        date.setDate(date.getDate() + Number(this.receptionStopDays));
        this.receptionStopDate = date;
      }
    },
    updateReceptionStopDate() {
      let start_date = new Date();
      if (this.receptionStart === "tomorrow") {
        start_date.setDate(start_date.getDate() + 1);
      }
      if (this.receptionStart === "other") {
        start_date = new Date(this.receptionStartDate);
      }
      let stop_date = new Date(this.receptionStopDate);
      let days = (stop_date - start_date) / (1000 * 60 * 60 * 24);
      if (days > 0) {
        this.receptionStopDays = String(Math.ceil(days));
      }
    },
    closeDelayMobile() {
      this.delayMobile = false;
      for (let item in this.receptionsDisplay) {
        for (let product in this.receptionsDisplay[item].products) {
          this.receptionsDisplay[item].products[product].delayMobile = false;
        }
      }
    },
    async getMedicineChestReceptions(id) {
      this.calendarDays = [];
      this.receptions = [];
      this.receptionsDisplay = [];
      let date_now = new Date();
      let date = new Date(
        date_now.getFullYear(),
        date_now.getMonth(),
        date_now.getDate(),
        3
      );
      this.selectedCalendarDate = String(date);
      try {
        const result = await api.shop.getMedicineChestReceptions(id);
        this.receptions = result["data"]["results"];
        let start_date = null;
        let stop_date = null;
        for (let reception in this.receptions) {
          reception = this.receptions[reception];
          if (!start_date) start_date = reception["start_date"];
          else if (start_date > reception["start_date"]) {
            start_date = reception["start_date"];
          }
          if (!stop_date) stop_date = reception["stop_date"];
          else if (stop_date < reception["stop_date"]) {
            stop_date = reception["stop_date"];
          }
        }
        start_date = new Date(start_date);
        stop_date = new Date(stop_date);
        let days = (stop_date - start_date) / (1000 * 60 * 60 * 24);
        for (let item = 0; item < days; item += 1) {
          let date = new Date(start_date);
          date.setDate(date.getDate() + item);
          this.calendarDays.push(date);
          if (String(date) === String(this.selectedCalendarDate)) {
            this.initialSlide = item - 3;
          }
        }
        this.getReceptionsDisplay(this.selectedCalendarDate);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async saveMedicineChest(isRedirect) {
      let error = false;
      let payload = {
        name: this.medicineChestName,
        timezone: this.mcTimezone,
        morning_hours: this.medicineChestMorning,
        lunch_hours: this.medicineChestLunch,
        supper_hours: this.medicineChestSupper,
        night_hours: this.medicineChestNight,
        is_notification_tg: this.isNotificationTg,
        is_notification_email: this.isNotificationEmail,
      };
      if (payload.name === "") {
        this.isMedicineChestName = true;
        error = true;
      } else this.isMedicineChestName = false;
      if (error) return false;
      try {
        if (this.openMedicineChest !== "new") {
          await api.shop.putMedicineChest(this.medicineChest.id, payload);
        } else {
          const result = await api.shop.postMedicineChest(payload);
          localStorage.setItem("medicineChestId", result["data"]["id"]);
        }
        if (isRedirect) location.reload();
      } catch (error) {
        console.log(error);
      }
    },
    async saveMedicineChestReception() {
      let payload = {
        medicine_chest_id: this.medicineChest.id,
        number_of_capsules: this.receptionNumber,
        type: 1,
        frequency: 1,
      };
      if (this.receptionType === "Утром во время еды") payload.type = 2;
      if (this.receptionType === "Утром после еды") payload.type = 3;
      if (this.receptionType === "Днем во время еды") payload.type = 4;
      if (this.receptionType === "Днем, через 1 час после еды") {
        payload.type = 5;
      }
      if (this.receptionType === "Вечером, во время еды") payload.type = 6;
      if (this.receptionType === "Вечером, перед сном") payload.type = 7;
      if (this.receptionFrequency === "1 день прием и 1 день перерыв") {
        payload.frequency = 2;
      }
      if (this.receptionFrequency === "2 дня прием и 2 дня перерыв") {
        payload.frequency = 3;
      }
      if (this.receptionFrequency === "5 дней прием и 2 дня перерыв") {
        payload.frequency = 4;
      }
      let start_date = new Date();
      if (this.receptionStart === "other") {
        start_date = this.receptionStartDate;
      } else if (this.receptionStart === "tomorrow") {
        start_date.setDate(start_date.getDate() + 1);
      }
      payload.start_date = start_date.getFullYear();
      payload.start_date += "-";
      payload.start_date += start_date.getMonth() + 1;
      payload.start_date += "-";
      payload.start_date += start_date.getDate();

      let stop_date = start_date;
      stop_date.setDate(stop_date.getDate() + Number(this.receptionStopDays));

      payload.stop_date = stop_date.getFullYear();
      payload.stop_date += "-";
      payload.stop_date += stop_date.getMonth() + 1;
      payload.stop_date += "-";
      payload.stop_date += stop_date.getDate();
      payload.days = Number(this.receptionStopDays);
      if (this.receptionProduct === "other") {
        payload.product_name = this.receptionProductOther;
      } else {
        payload.product_id = this.receptionProduct.id;
      }
      try {
        if (this.openMedicineChestReception !== "new") {
          await api.shop.putMedicineChestReception(
            this.openMedicineChestReception.id,
            payload
          );
        } else await api.shop.postMedicineChestReception(payload);
        location.reload();
      } catch (error) {
        console.log(error);
      }
    },
    async confirmAcceptance(product) {
      product.status = 2;
      try {
        await api.shop.putMedicineChestReceptionAcceptance(product.id);
      } catch (error) {
        console.log(error);
      }
    },
    getReceptionsDisplay(value) {
      value = new Date(value);
      let date = new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        3
      );
      date = String(date);
      this.receptionsDisplay = {};
      for (let reception in this.receptions) {
        reception = this.receptions[reception];
        let calendar_day = String(new Date(reception["calendar_date"]));
        if (date === calendar_day) {
          if (!this.receptionsDisplay[reception["type"]]) {
            this.receptionsDisplay[reception["type"]] = {
              type: reception["type"],
              products: [],
            };
          }
          if (reception["product_id"]) {
            reception["product"] = this.products[reception["product_id"]];
          }
          this.receptionsDisplay[reception["type"]].products.push(reception);
        }
      }
    },
    getWeekName(item) {
      let value = item.getDay();
      if (value === 0) return "ВС";
      if (value === 1) return "ПН";
      if (value === 2) return "ВТ";
      if (value === 3) return "СР";
      if (value === 4) return "ЧТ";
      if (value === 5) return "ПТ";
      if (value === 6) return "СБ";
    },
    getDayMonthName(item) {
      let day = item.getDate();
      let value = item.getMonth() + 1;
      if (value === 1) return day + " янв";
      if (value === 2) return day + " фев";
      if (value === 3) return day + " мар";
      if (value === 4) return day + " апр";
      if (value === 5) return day + " май";
      if (value === 6) return day + " июн";
      if (value === 7) return day + " июл";
      if (value === 8) return day + " авг";
      if (value === 9) return day + " сен";
      if (value === 10) return day + " окт";
      if (value === 11) return day + " ноя";
      if (value === 12) return day + " дек";
    },
    getReceptionDeclination(product) {
      if (!product.product) return "шт.";
      if (!product.product.release_form) return "шт.";
      return this.getDeclination(
        product.number_of_capsules,
        product.product.release_form
      );
    },
    medicineChestSettings() {
      this.openMedicineChestSettings = true;
      this.medicineChestName = this.medicineChest.name;
      this.mcTimezone = this.medicineChest.timezone;
      this.medicineChestMorning = this.medicineChest.morning_hours;
      this.medicineChestLunch = this.medicineChest.lunch_hours;
      this.medicineChestSupper = this.medicineChest.supper_hours;
      this.medicineChestNight = this.medicineChest.night_hours;
      this.isNotificationTg = this.medicineChest.is_notification_tg;
      this.isNotificationEmail = this.medicineChest.is_notification_email;
    },
    medicineChestReceptionSettings(item, isDelay = false) {
      if (window.innerWidth < 900 && isDelay === false) {
        item.delayMobile = true;
        this.delayMobile = true;
        return false;
      }

      this.isOpenMedicineChestReception = true;
      this.openMedicineChestReception = item;
      if (item["type"] === 1) this.receptionType = "Утром до еды";
      if (item["type"] === 2) this.receptionType = "Утром во время еды";
      if (item["type"] === 3) this.receptionType = "Утром после еды";
      if (item["type"] === 4) this.receptionType = "Днем во время еды";
      if (item["type"] === 5) {
        this.receptionType = "Днем, через 1 час после еды";
      }
      if (item["type"] === 6) this.receptionType = "Вечером, во время еды";
      if (item["type"] === 7) this.receptionType = "Вечером, перед сном";
      if (item.product) {
        this.receptionProduct = item.product;
        this.receptionProductOther = "";
      } else {
        this.receptionProduct = "other";
        this.receptionProductOther = item.product_name;
      }
      this.receptionNumber = item["number_of_capsules"];
      this.receptionStartDate = new Date(item["start_date"]);
      this.receptionStopDate = new Date(item["stop_date"]);
      this.updateReceptionStopDate();
      if (item["frequency"] === 1) this.receptionFrequency = "Ежедневно";
      if (item["frequency"] === 2) {
        this.receptionFrequency = "1 день прием и 1 день перерыв";
      }
      if (item["frequency"] === 3) {
        this.receptionFrequency = "2 дня прием и 2 дня перерыв";
      }
      if (item["frequency"] === 4) {
        this.receptionFrequency = "5 дней прием и 2 дня перерыв";
      }
    },
    clickOpenReceptionType() {
      if (this.isOpenReceptionType) {
        this.isOpenReceptionType = false;
        this.isOpenMedicineChestReception = true;
      } else {
        this.isOpenMedicineChestReception = false;
        this.isOpenReceptionType = true;
      }
    },
    clickOpenReceptionFrequency() {
      if (this.isOpenReceptionFrequency) {
        this.isOpenReceptionFrequency = false;
        this.isOpenMedicineChestReception = true;
      } else {
        this.isOpenMedicineChestReception = false;
        this.isOpenReceptionFrequency = true;
      }
    },
    clickOpenReceptionDate() {
      if (this.isOpenReceptionDate) {
        this.isOpenReceptionDate = false;
        this.isOpenMedicineChestReception = true;
      } else {
        this.isOpenMedicineChestReception = false;
        this.isOpenReceptionDate = true;
      }
    },
    clickOpenReceptionProduct(item = null) {
      if (this.isOpenReceptionProduct) {
        this.isOpenReceptionProduct = false;
        if (item) {
          this.receptionProduct = item;
          this.updateReceptionProduct();
        }
        this.isOpenMedicineChestReception = true;
      } else {
        this.isOpenMedicineChestReception = false;
        this.isOpenReceptionProduct = true;
      }
    },
    clickOpenReceptionProductOther() {
      if (this.isOpenReceptionProductOther) {
        this.receptionProduct = "other";
        this.isOpenReceptionProductOther = false;
        this.isOpenReceptionProduct = false;
        this.isOpenMedicineChestReception = true;
      } else {
        this.isOpenMedicineChestReception = false;
        this.isOpenReceptionProduct = false;
        this.isOpenReceptionProductOther = true;
      }
    },
    clickOpenMedicineChestTimezone() {
      if (this.isOpenMedicineChestTimezone) {
        this.isOpenMedicineChestTimezone = false;
        this.isOpenMedicineChest = true;
      } else {
        this.isOpenMedicineChest = false;
        this.isOpenMedicineChestTimezone = true;
      }
    },
    clickNotificationTg(value) {
      this.isNotificationTg = value;
      this.medicineChest.is_notification_tg = value;
      if (value) {
        window.open(
          "https://t.me/ultrabalance_assistant_bot?start=" +
            this.medicineChest.code
        );
      }
      this.saveMedicineChest(false);
    },
    clickNotificationEmail(value) {
      this.isNotificationEmail = value;
      this.medicineChest.is_notification_email = value;
      this.saveMedicineChest(false);
    },
    getMinMinute(value) {
      let result = Number(value.split(":")[0]) - 1;
      return result + ":30";
    },
    getPlusHours(value) {
      let result = Number(value.split(":")[0]) + 1;
      return result + ":00";
    },
    checkDates(date1, date2) {
      let result = 3;
      if (!date1 || !date2) return false;
      if (date1.getMonth() === date2.getMonth()) result -= 1;
      if (date1.getDate() === date2.getDate()) result -= 1;
      if (date1.getFullYear() === date2.getFullYear()) result -= 1;
      // alert(result);
      if (result === 0) return true;
      return false;
    },
  },
};
</script>
